import Image from 'next/image';
import Link from 'next/link';

interface LandingBrandProps {
  brand?: 'os-group' | 'tradegrid';
  priority?: boolean;
  tone?: 'default' | 'inverse';
}

export function LandingBrand({
  brand = 'os-group',
  priority = false,
  tone = 'default',
}: LandingBrandProps) {
  if (brand === 'tradegrid') {
    return (
      <Link
        href="/"
        className="flex items-center gap-2 font-[family-name:var(--font-dm-sans)]"
        aria-label="Tradegrid home"
      >
        <span className="relative h-10 w-8 shrink-0 overflow-hidden" aria-hidden="true">
          <Image
            src="/images/logo.png"
            alt=""
            width={264}
            height={143}
            className="absolute left-0 top-1/2 h-10 w-auto max-w-none -translate-y-1/2"
            priority={priority}
          />
        </span>
        <span className="flex flex-col leading-none">
          <span
            className={`text-base font-semibold tracking-tight ${tone === 'inverse' ? 'text-white' : 'text-foreground'}`}
          >
            Tradegrid
          </span>
          <span
            className={`mt-0.5 text-[0.625rem] font-medium tracking-[-0.01em] ${tone === 'inverse' ? 'text-white/60' : 'text-muted-foreground'}`}
          >
            Powered by <span className="text-brand">OS</span>
          </span>
        </span>
      </Link>
    );
  }

  return (
    <Link
      href="/"
      className="flex items-center gap-2.5 font-[family-name:var(--font-dm-sans)]"
      aria-label="OS Group home"
    >
      <span className="relative h-10 w-8 shrink-0 overflow-hidden" aria-hidden="true">
        <Image
          src="/images/logo.png"
          alt=""
          width={264}
          height={143}
          className="absolute left-0 top-1/2 h-10 w-auto max-w-none -translate-y-1/2"
          priority={priority}
        />
      </span>
      <span
        className={`text-lg font-semibold tracking-tight ${tone === 'inverse' ? 'text-white' : 'text-foreground'}`}
      >
        OS Group
      </span>
    </Link>
  );
}
